
import { Component, Vue, Prop } from "nuxt-property-decorator";

@Component
export default class CategoryTipology extends Vue {
  @Prop() item!: any;
  @Prop() iscard!: boolean;
}
